import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp, getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTab from "@shared/components/SnTab";
import { showDialog } from "@widgets/CommonDialog";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_PRD_MRE_REG_001_CHEM_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
      grid3: React.createRef(),
      grid4: React.createRef(),
    });

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
      grid4: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
      grid4: [],
    });

    const [popupParent, setPopupParent] = useState<any>(null);
    const [selectedTabPage, setTapPage] = useState<string>("1");

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        let checkValidity = false;
        switch (selectedTabPage) {
          case "1":
            checkValidity = checkValid1();
            break;
          case "2":
            checkValidity = checkValid2();
            break;
        }
        return checkValidity;
      },
      getOkayData: () => {
        let result;
        if (selectedTabPage === "1") {
          result = [
            gridRefs.current["grid1"].current?.getCheckedRows() || [],
            gridRefs.current["grid2"].current?.getCheckedRows() || [],
          ];
        } else {
          result = [
            gridRefs.current["grid3"].current?.getCheckedRows() || [],
            gridRefs.current["grid4"].current?.getCheckedRows() || [],
          ];
        }
        return {
          rtnData: result,
        };
      },
    }));

    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_PRD_MRE_REG_001_CHEM_POP_001",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
            grid3: rtn.grid.grid3,
            grid4: rtn.grid.grid4,
          });
        } catch (error) {}
      };
      fetchform();
    }, []);

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_prd_mre_reg_001_chem_pop_01",
          params: searchRef.current.getFormdata(),
        };
        gridRefs.current["grid1"].current.resetUpdate();
        gridRefs.current["grid2"].current.resetUpdate();
        gridRefs.current["grid3"].current.resetUpdate();
        gridRefs.current["grid4"].current.resetUpdate();
        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0] || [],
          grid2: data[1] || [],
          grid3: data[2] || [],
          grid4: data[3] || [],
        });
      } catch (error: any) {}
    };

    const onTabChanged = (index: string) => {
      setTapPage(index);
    };

    const onCheckedRowChanged1 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        gridRefs.current["grid2"].current.setCheckedAll(value);
      } else {
        gridRefs.current["grid2"].current.setCheckedAllWithFilter(value);
      }
    };

    const onCheckedRowChanged2 = (value: boolean) => {
      const checkedRows =
        gridRefs.current["grid2"].current.getCheckedFilteredRows();
      if (checkedRows.length > 0)
        gridRefs.current["grid1"].current.setCheckedFocusedRow(true, "noEvent");
      else
        gridRefs.current["grid1"].current.setCheckedFocusedRow(
          false,
          "noEvent"
        );
    };

    const onCheckedRowChanged3 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        gridRefs.current["grid4"].current.setCheckedAll(value);
      } else {
        gridRefs.current["grid4"].current.setCheckedAllWithFilter(value);
      }
    };

    const onCheckedRowChanged4 = (value: boolean) => {
      const checkedRows =
        gridRefs.current["grid4"].current.getCheckedFilteredRows();
      if (checkedRows.length > 0)
        gridRefs.current["grid3"].current.setCheckedFocusedRow(true, "noEvent");
      else
        gridRefs.current["grid3"].current.setCheckedFocusedRow(
          false,
          "noEvent"
        );
    };

    const checkValid1 = () => {
      const checkdRows = gridRefs.current["grid1"].current.getCheckedRows();
      if (checkdRows.length <= 1) return true;

      // 거래처 중복 여부 확인
      const check_cdCust = new Set(
        checkdRows.map((row: any) => (row.cd_cust || "").trim())
      );
      if (check_cdCust.size > 1) {
        showDialog("alter", "서로 다른 고객을 선택하셨습니다.");
        return false;
      }

      // 수주형태 중복 여부 확인
      const check_cdSo = new Set(
        checkdRows.map((row: any) => (row.cd_so || "").trim())
      );
      if (check_cdSo.size > 1) {
        showDialog("alter", "서로 다른 수주형태를 선택하셨습니다.");
        return false;
      }
      return true;
    };

    const checkValid2 = () => {
      const checkedRows = gridRefs.current["grid3"].current.getCheckedRows();
      if (checkedRows.length <= 1) return true;

      // 거래처 중복 여부 확인
      const check_cdCust = new Set(
        checkedRows.map((row: { cd_cust: any }) => row.cd_cust)
      );
      if (check_cdCust.size > 1) {
        showDialog("alter", "서로 다른 고객을 선택하셨습니다.");
        return false;
      }

      // 환종 중복 여부 확인
      const check_cdExch = new Set(
        checkedRows.map((row: { cd_exch: any }) => row.cd_exch)
      );
      if (check_cdExch.size > 1) {
        showDialog("alter", "서로 다른 환종을 선택하셨습니다.");
        return false;
      }

      // 환율 중복 여부 확인
      const check_rtExch = new Set(
        checkedRows.map((row: { rt_exch: any }) => row.rt_exch)
      );
      if (check_rtExch.size > 1) {
        showDialog("alter", "서로 다른 환율을 선택하셨습니다.");
        return false;
      }

      // 수불형태(유무환) 중복 여부 확인
      const check_fgMoney = new Set(
        checkedRows.map((row: { fg_money: any }) => row.fg_money)
      );
      if (check_fgMoney.size > 1) {
        showDialog("alter", "서로 다른 유무환 구분을 선택하셨습니다.");
        return false;
      }

      // 수주형태 중복 여부 확인
      const check_cdSo = new Set(
        checkedRows.map((row: { cd_so: any }) => row.cd_so)
      );
      if (check_cdSo.size > 1) {
        showDialog("alter", "서로 다른 수주형태를 선택하셨습니다.");
        return false;
      }
      return true;
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onCheckedRowChaged: onCheckedRowChanged1,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onCheckedRowChaged: onCheckedRowChanged2,
          },
        },
        grid3: {
          columns: columns.grid3,
          dataSource: dataSources.grid3,
          events: {
            onCheckedRowChaged: onCheckedRowChanged3,
          },
        },
        grid4: {
          columns: columns.grid4,
          dataSource: dataSources.grid4,
          events: { onCheckedRowChaged: onCheckedRowChanged4 },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div className="mb-2" style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div className="flex-1 h-full min-h-0 space-y-1.5">
          <SnTab
            titles={["지시의뢰별", "품목별"]}
            width={"100%"}
            onTabChanged={onTabChanged}
            body={[
              <div className="h-full flex flex-col gap-y-1.5">
                <SnGrid
                  ref={gridRefs.current["grid1"]}
                  columnConfig={grids.grid1.columns}
                  rowData={grids.grid1.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                    popupParent: popupParent,
                  }}
                  events={grids.grid1.events}
                  filter={{
                    refs: [gridRefs.current["grid2"]],
                    columns: ["no_woreq"],
                  }}
                />
                <SnGrid
                  ref={gridRefs.current["grid2"]}
                  columnConfig={grids.grid2.columns}
                  rowData={grids.grid2.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                    popupParent: popupParent,
                  }}
                  events={grids.grid2.events}
                />
              </div>,

              <div className="h-full flex flex-col gap-y-1.5">
                <SnGrid
                  ref={gridRefs.current["grid3"]}
                  columnConfig={grids.grid3.columns}
                  rowData={grids.grid3.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                    popupParent: popupParent,
                  }}
                  events={grids.grid3.events}
                  filter={{
                    refs: [gridRefs.current["grid4"]],
                    columns: ["cd_item", "no_woreq", "no_line"],
                  }}
                />
                <SnGrid
                  ref={gridRefs.current["grid4"]}
                  columnConfig={grids.grid4.columns}
                  rowData={grids.grid4.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                    popupParent: popupParent,
                  }}
                  events={grids.grid4.events}
                />
              </div>,
            ]}
          />
        </div>
      </div>
    );
  }
);

export default SN_PRD_MRE_REG_001_CHEM_POP_001;
